import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'is-commercial-property',
    templateUrl: './commercial-property.component.html',
    styleUrls: ['./commercial-property.component.scss'],
    standalone: false
})
export class CommercialPropertyComponent implements OnInit {
    @Input() fnolForm: UntypedFormGroup;
    commercialPropertyForm: UntypedFormGroup;
    damagedAreasList: UntypedFormArray = new UntypedFormArray([], Validators.required);
    damages: any[] = [
        { description: 'Detached structure', value: 'detachedStructure' },
        { description: 'Contents', value: 'contents' },
        { description: 'Farm structure', value: 'farmStructure' },
        { description: 'Building', value: 'building' },
        { description: 'Business personal property', value: 'businessPersonalProperty' }
    ];
    primaryCause: UntypedFormControl = new UntypedFormControl('', Validators.required);
    primaryCauses: string[] = ['Collapse from Ice/Snow/Sleet', 'Collapse (not from Ice/Snow/Sleet)', 'Equipment Breakdown/Power Surge',
        'Explosion', 'Fire', 'Flood', 'Freezing', 'Glass Breakage Only', 'Hail Damage', 'Identity Theft', 'Lightning', 'Loading/Unloading',
        'Lost Item/Mysterious Disappearance', 'Riot/Civil Commotion', 'Sinkhole', 'Smoke', 'Terrorism', 'Theft ', 'Theft By Employee',
        'Utility/Power Outage', 'Vandalism', 'Vehicle/Watercraft/Aircraft', 'Volcanic Action', 'Water Damage (from weather)',
        'Water Damage (not from weather)', 'Wind Damage', 'Earthquake/Earth Movement/Landslide', 'All Other Physical Damage'];

    totalAmountLostAnswer: UntypedFormControl = new UntypedFormControl('', Validators.required);

    constructor(private formBuilder: UntypedFormBuilder) { }
    buildForm(): void {
        // Need to add new regex validations for claims fields
        this.fnolForm.addControl('commercialProperty', this.commercialPropertyForm = this.formBuilder.group({
            primaryCause: this.primaryCause,
            damagedAreasList: this.damagedAreasList,
            totalAmountLostAnswer: this.totalAmountLostAnswer
        }));
    }

    ngOnInit(): void {
        this.buildForm();
    }

    // function is responsible for updating damagedAreasList when the checkboxes are checked
    onDamageChange(event): void {
        if (event.target.checked) {
            // Add a new control in the arrayForm
            this.damagedAreasList.push(new UntypedFormControl(event.target.value));
        } else {
            let index = 0;
            this.damagedAreasList.controls.forEach((ctrl: UntypedFormControl) => {
                if (ctrl.value === event.target.value) {
                    // Remove the unselected element from the arrayForm
                    this.damagedAreasList.removeAt(index);
                    return;
                }
                index++;
            });
        }
        this.damagedAreasList.markAsTouched();
    }
}
